import React, { Dispatch, SetStateAction } from 'react'
import { Alert, Modal } from 'components'

import * as S from './styles'

interface ModalConfirmGenerationProps {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
  onConfirm: () => void
  onReturn?: () => void
}

const ModalConfirmGeneration: React.FC<ModalConfirmGenerationProps> = ({
  open,
  setOpen,
  onConfirm,
  onReturn = () => setOpen(false)
}) => {
  return (
    <Modal
      open={open}
      titleSize={22}
      modalWidth={456}
      setOpen={setOpen}
      showReturn
      returnIcon={''}
      returnText="Gerenciamento"
      returnAction={onReturn}
      buttonText="Criar novo pedido"
      buttonAction={onConfirm}
      showClose={false}
      closeAction={onConfirm}
    >
      <S.DescriptionContainer>
        <Alert
          kind="success"
          title={'Geração de OVs iniciada!'}
          message="Assim que o sistema concluir a geração, uma notificação será enviada para o seu email."
          fullWidth
        />
        <S.ObservationText>
          Enquanto aguarda por um retorno do Portal, você pode criar novos pedidos.
        </S.ObservationText>
        <S.ObservationText>
          As OVs geradas serão <b>enviadas automaticamente ao SAP.</b> Materiais em aberto
          ou em análise <b>não possuem garantia de disponibilidade.</b>
        </S.ObservationText>
      </S.DescriptionContainer>
    </Modal>
  )
}

export default ModalConfirmGeneration
